import { useOrdersConfig } from '../config';
import ExportButton from './ExportButton';
import useMobileLayout from 'shared/hooks/useMobileLayout';

function Header() {
  const isMobileLayout = useMobileLayout();
  const { title } = useOrdersConfig();

  return (
    <div className="flex flex-col gap-4 w-full sm:flex-row sm:items-center sm:justify-between sm:gap-10">
      <div className="font-klarheit tracking-tight text-4xl whitespace-nowrap text-right sm:text-left">{title}</div>
      <div className={`flex ${isMobileLayout ? 'w-full justify-end' : ''}`}>
        <ExportButton />
      </div>
    </div>
  );
}

export default Header;
